<template>
    <div>
        <div v-if="data.length > 0" v-for="(error,index) in data" class="sammio__alert alert p-3 my-3 " role="alert" :key="index">
          <div class="row align-items-center">
            <div class="col-2 col-md-auto">
              <alert-triangle-icon size="3x" class="sammio-actions__icon"></alert-triangle-icon>
            </div>
            <div class="col-10 col-md-10">
              <h4 v-if="error.code !== ''"> {{ error.code}} </h4>
              <p v-if="error.text !== ''"> {{ error.text }} </p>
            </div>
          </div>
        </div>

    </div>
</template>
<script>
import { AlertTriangleIcon} from 'vue-feather-icons'
    export default {
        name: "SammioErrors",
        props: [ 'target', 'data' ],
        components: {
          AlertTriangleIcon
        }
    }
</script>
